import { render, staticRenderFns } from "./A14Info.vue?vue&type=template&id=0385a19f&"
import script from "./A14Info.vue?vue&type=script&lang=ts&"
export * from "./A14Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports